import { mobileMenu } from './components/mobileMenu';
import { desktopMenu } from './components/desktopMenu';
// import { parallax } from './components/parallax';
import { gforms } from './components/gforms';
// import { marquee } from './components/marquee';

import { alignFull } from './components/alignFull';
import { gallery } from './components/gallery';
import { responsiveEmbeds } from './components/responsiveEmbeds';
import { search, closeSearch } from './components/search';
import { loadMore } from './components/loadMore';
import { coverPoster } from './components/coverPoster';
import { videoButton } from './components/videoButton';
import { toggle } from './components/toggle';
import { slider } from './components/slider';
// import { unSplash } from './components/unSplash';

global.$ = global.jQuery;

$(() => {
  console.log('init');
  mobileMenu();
  desktopMenu();
  gforms();
  // parallax();
  // marquee();
  // unSplash();
  slider();
  toggle();
  loadMore();
  gallery();
  videoButton();
  coverPoster();
  responsiveEmbeds();
  search();
  alignFull();

  // close open things on escape
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeSearch();
    }
  });

  $('.pattern-arrow svg')
    .css({ cursor: 'pointer' })
    .on('click', function () {
      // scroll next section in view
      const $next = $(this).closest('.wp-block-cover').next();

      $('html, body').animate({ scrollTop: $next.offset().top }, 500);
    });
});
